import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  ActiveInactiveCountry,
  createCountry,
  deleteCountry,
  getAllActiveCountry,
  getAllCountry,
  getCountryByID,
  updateCountry,
} from "./services/country.services";

export interface ICountryState {
  loading: boolean;
  formloading: boolean;
  error: string;
  CountryID: number | null;
  CountryList: ICountry[];
  CountryDetail: ICountryDetails;
}

export interface ICountryDetails {
  ID?: number | null;
  Country: string;
  IsActive: number | boolean;
}
export interface ICountry {
  Name: string;
  Image: string;
  IsActive: number | boolean;
}

const initialState: ICountryState = {
  loading: false,
  formloading: false,
  error: "",
  CountryID: null,
  CountryList: [],
  CountryDetail: {
    Country: "",
    IsActive: 1,
  },
};

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    clearCountryDetails: (state) => {
      state.CountryDetail = initialState.CountryDetail;
    },
    setCountryID: (state, action) => {
      state.CountryID = action.payload;
    },
    clearCountryID: (state) => {
      state.CountryID = initialState.CountryID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCountry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCountry.fulfilled,
      (state, action: PayloadAction<ICountry[]>) => {
        state.loading = false;
        state.CountryList = action.payload || [];
      }
    );
    builder.addCase(getAllCountry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CountryList = [];
    });
    builder.addCase(createCountry.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(createCountry.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(createCountry.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateCountry.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(updateCountry.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(updateCountry.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteCountry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCountry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCountry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCountryByID.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(getCountryByID.fulfilled, (state, action: any) => {
      state.formloading = false;
      state.CountryDetail = action.payload;
    });
    builder.addCase(getCountryByID.rejected, (state, action) => {
      state.formloading = false;
      state.CountryDetail = initialState.CountryDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveCountry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveCountry.fulfilled,
      (state, action: PayloadAction<ICountry[]>) => {
        state.loading = false;
        state.CountryList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveCountry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CountryList = [];
    });
    builder.addCase(ActiveInactiveCountry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveCountry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveCountry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearCountryDetails, clearCountryID, setCountryID } = countrySlice.actions;
export default countrySlice.reducer;
